// @flow
import React from 'react';

import config from 'Config';
import { formatFooterLabelName } from 'Utils/tracking/footer';
import { isPhoneNumber } from 'Utils/regex/RegexHelper';
import { BlockLink } from 'Components/frameworks/block-link/BlockLink.jsx';
import { WebCallbackBlockLink } from 'Components/widgets/webcallback/WebCallbackBlockLink.jsx';

export const WEB_CALLBACK_LINK = 'callMeBack';
export const WEB_CALLBACK_ENABLED = config.get('freespee.enabled');

export function FooterContacts({ items = [] }: { items: CMSFooterContacts }) {
  return (
    <div className="pt-4 relative w-full z-1 lg:border-b-1 border-gray-dark md:pb-4">
      <ul className="reset-list flex flex-col md:flex-row md:justify-between md:-mx-1">
        {items.map(({ href, text, type }) => {
          const texts = (text || []).map(txt => {
            // the phone number is always written in ltr, even in he-IL (which is rtl)
            return isPhoneNumber(txt) ? <span dir="ltr">{txt}</span> : txt;
          });
          return (
            <li
              className="border-b-1 md:border-b-0 border-gray-dark mb-3 md:mb-0 md:mx-1 pb-3 md:pb-0 last-child-mb-0 last-child-border-b-0"
              key={type}
            >
              {type === WEB_CALLBACK_LINK && WEB_CALLBACK_ENABLED ? (
                <WebCallbackBlockLink
                  icon={type}
                  trackingData={{ actionGA: 'footer' }}
                  texts={texts}
                  theme="default"
                />
              ) : (
                <BlockLink
                  icon={type}
                  target="_blank"
                  texts={texts}
                  trackingData={{
                    actionGA: 'footer',
                    labelGA: formatFooterLabelName(type),
                  }}
                  url={href}
                />
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
